import { render, staticRenderFns } from "./MultiConsult.vue?vue&type=template&id=550faca4&scoped=true&"
import script from "./MultiConsult.vue?vue&type=script&lang=js&"
export * from "./MultiConsult.vue?vue&type=script&lang=js&"
import style0 from "./MultiConsult.vue?vue&type=style&index=0&id=550faca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550faca4",
  null
  
)

export default component.exports